import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, LOGO, GLOBS } from "./theme";
import { Background } from "./Background";

function Stars({ count }: { count: number }) {
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span
          key={i}
          style={{
            fontSize: 24,
            color: i < count ? COLORS.gold : COLORS.darkAlt,
            textShadow: i < count ? `0 0 12px ${COLORS.gold}40` : "none",
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
}

export const Depoimento: React.FC<{
  quote: string;
  author: string;
  detail: string;
  rating: number;
}> = ({ quote, author, detail, rating }) => {
  return (
    <AbsoluteFill
      style={{
        background: `linear-gradient(160deg, ${COLORS.dark} 0%, ${COLORS.darkAlt} 100%)`,
        fontFamily: FONTS.sans,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "80px 100px",
      }}
    >
      <Background theme="dark" />

      <div
        style={{
          position: "absolute",
          top: -120,
          right: -80,
          width: 450,
          height: 450,
          borderRadius: "50%",
          background: GLOBS.goldGlow,
          filter: "blur(80px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: -150,
          left: -80,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: GLOBS.darkGlow,
          filter: "blur(80px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "20%",
          right: 40,
          width: 200,
          height: 200,
          borderRadius: "50%",
          border: "1px solid rgba(197,160,89,0.08)",
          opacity: 0.3,
        }}
      />

      <div style={{ marginBottom: 16, zIndex: 2 }}>
        <Stars count={rating} />
      </div>

      <div
        style={{
          fontSize: 100,
          color: COLORS.gold,
          fontFamily: FONTS.serif,
          lineHeight: 0.5,
          marginTop: 8,
          marginBottom: 16,
          opacity: 0.2,
          zIndex: 2,
          textShadow: `0 0 30px ${COLORS.gold}20`,
        }}
      >
        "
      </div>

      <div
        style={{
          fontFamily: FONTS.serif,
          fontSize: 30,
          fontWeight: 400,
          color: COLORS.white,
          lineHeight: 1.5,
          fontStyle: "italic",
          maxWidth: "90%",
          marginBottom: 32,
          zIndex: 2,
          textShadow: "0 2px 8px rgba(0,0,0,0.3)",
        }}
      >
        {quote}
      </div>

      <div
        style={{
          borderTop: `1px solid rgba(255,255,255,0.06)`,
          paddingTop: 20,
          display: "flex",
          alignItems: "center",
          gap: 16,
          zIndex: 2,
        }}
      >
        <div
          style={{
            ...LOGO,
            width: 48,
            height: 48,
            fontSize: 20,
            color: COLORS.dark,
          }}
        >
          {author.charAt(0)}
        </div>
        <div>
          <div
            style={{
              fontSize: 17,
              fontWeight: 600,
              color: COLORS.white,
            }}
          >
            {author}
          </div>
          <div style={{ fontSize: 14, color: COLORS.stoneMuted }}>
            {detail}
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};
